<button type="button"
        class="copy-email copy-email--{{ variant }} copy-email--{{ tone }}"
        [class.copy-email--copied]="copied()"
        [attr.aria-label]="'Copy email address ' + email"
        (click)="copy()">
  <span class="copy-email__text">{{ email }}</span>
  <svg class="copy-email__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
  </svg>
  @if (variant === 'boxed') {
    <span class="copy-email__label" aria-hidden="true">{{ copied() ? 'Copied!' : 'Copy' }}</span>
  } @else if (copied()) {
    <span class="copy-email__label" aria-hidden="true">Copied!</span>
  }
</button>
<span class="visually-hidden" aria-live="polite">{{ copied() ? 'Email address copied' : '' }}</span>
